import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0); // First item is open by default

  const faqs = [
    {
      question: 'What is a captive insurance company?',
      answer: 'An insurance captive is a wholly owned subsidiary insurance company created by a parent organization to insure the risks of its owner(s)',
      height: 'h-36' // 144px
    },
    {
      question: 'How much capital do I need to start a captive?',
      answer: 'Captive capital requirements start with the domicile\'s statutory minimum, which varies by jurisdiction and captive structure. The feasibility study then calculates risk-based capital needs based on expected premium volume, projected losses, type of risk being written, and reinsurance structure.',
      height: 'h-20' // 80px
    },
    {
      question: 'What size portfolio do I need to benefit from a captive?',
      answer: 'While there is no "one-size-fits-all" number, most businesses find that an annual premium of $250k to $500k is the sweet spot to make a protected cell or rent-a-captive structure cost-effective. These programs are specifically designed for smaller to mid-sized portfolios because they allow you to share administrative overhead while still gaining the tax and underwriting benefits of a formal captive. Ultimately, if your predictable loss history is lower than the commercial markets premiums, the size of your portfolio is likely sufficient to see a significant ROI.',
      height: 'h-20' // 112px
    },
    {
      question: 'How does compliance verification work?',
      answer: 'Compliance verification for captive insurance companies operates through a multi-layered framework involving domicile regulators, tax authorities (IRS), and third-party auditors. The verification process focuses on validating that the captive maintains legitimate business purpose, demonstrates true risk transfer, adheres to capitalization requirements, and follows proper corporate governance.',
      height: 'h-20' // 80px
    },
    {
      question: 'What happens if claims exceed premiums?',
      answer: 'When claims exceed premiums in a captive insurance company, the captive operates at an underwriting loss for that period. Unlike traditional insurance where the insurer absorbs these losses, captives have specific mechanisms and capital structures designed to handle this scenario. The outcome depends on the captives capitalization, reinsurance structure, and type of captive arrangement.',
      height: 'h-20' // 80px
    },
    {
      question: 'How long does it take to set up a captive?',
      answer: 'The timeline depends primarily on captive structure and can range from 30 days to 12 months —a Rent-A-Captive or Protected Cell Captive (PCC) can be operational in 1-6 months since youre leveraging existing infrastructure, while a Pure Captive/Single-Parent Captive may require 6-12 months due to full regulatory licensing, capitalization requirements, and governance establishment. Additional timeline factors include domicile selection, regulatory approval processes, capital formation complexity, and your companys risk profile and reinsurance program design.',
      height: 'h-20' // 80px
    },
    {
      question: 'Which property management systems do you integrate with?',
      answer: 'Through seamless integration with Yardi and Entrata, we automate the flow of insurance data and premium charges directly into your property management workflow, eliminating manual data entry and reconciliation. Our bi-directional API connection enables certificate verification, automated billing for tenant insurance programs, and consolidated reporting across all properties in your portfolio.',
      height: 'h-28' // 112px
    },
    {
      question: 'What are the ongoing costs?',
      answer: 'Managing a captive insurance company involves various ongoing costs essential for its operation and compliance. These annual expenses, typically ranging from 15% to 35% of the written premium, cover management fees, actuarial services, legal and accounting support, and regulatory compliance. Furthermore, captive owners must also account for claims liability, reinsurance premiums, and potential fronting fees to ensure the programs long-term financial health and success.',
      height: 'h-20' // 80px
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-wrapper" id="faq">
      {/* Vertical Dividers */}
      <div className="faq-divider faq-divider-1"></div>
      <div className="faq-divider faq-divider-2"></div>
      <div className="faq-divider faq-divider-3"></div>
      <div className="faq-divider faq-divider-4"></div>
      <div className="faq-divider faq-divider-5"></div>

      {/* Title Section */}
      <div className="faq-title-section">
        <h2 className="faq-title">Frequently Asked Questions</h2>
      </div>

      {/* FAQ Items Column */}
      <div className="faq-items-column">
        {faqs.map((faq, index) => {
          const isActive = activeIndex === index;
          const isFirst = index === 0;
          const isLast = index === faqs.length - 1;
          
          return (
            <div
              className={`faq-item ${isActive ? 'active' : ''} ${isFirst ? 'first-item' : ''} ${isLast ? 'last-item' : ''}`}
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-item-content">
                <div className="faq-question-text">
                  <div className="faq-question">{faq.question}</div>
                  <div className={`faq-answer-wrapper ${isActive ? 'active' : ''}`}>
                    {faq.answer && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </div>
                <div className="faq-icon-wrapper">
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none"
                    className={`faq-icon ${isActive ? 'active' : ''}`}
                  >
                    <line x1="12" y1="5" x2="12" y2="19" stroke="#111111" strokeWidth="2" strokeLinecap="round"/>
                    <line 
                      x1="5" 
                      y1="12" 
                      x2="19" 
                      y2="12" 
                      stroke="#111111" 
                      strokeWidth="2" 
                      strokeLinecap="round"
                      className="faq-icon-horizontal"
                    />
                  </svg>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Corner Indicators */}
      <div className="faq-corner faq-corner-1"></div>
      <div className="faq-corner faq-corner-2"></div>
    </section>
  );
};

export default FAQ;
